import { faBan, faFileText, faUserShield } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Card, Col, Row, Stack, Image, Modal } from "react-bootstrap";
import CreateNoteModal from "../ui/CreateNoteModal";
import { useNavigate } from "react-router-dom";
import IconEmbeddedButton from "../ui/IconEmbeddedButton";
import { Tooltip } from "react-tooltip";
import useApp from "../../utils/useApp";

interface PeopleCardState {
  person: any;
  types: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
  limitedAccess: boolean;
}

const PeopleCard = ({ person, types, setShowToast, setToastText, setToastBody, limitedAccess }: PeopleCardState) => {
  const [show, setShow] = useState(false);
  const [currentImage, setCurrentImage] = useState<string>("");
  const [banDateExpired, setBanDateExpired] = useState<boolean>(false);
  const [showCreateNote, setShowCreateNote] = useState<boolean>(false);
  const [userToSave, setUserToSave] = useState<boolean>(false);

  useEffect(() => {
    //check ban expiration date
    if (person.banned_expiration_at) {
      const expireDate = new Date(person?.banned_expiration_at);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      setBanDateExpired(expireDate <= today);
    }
  }, [person]);

  let navigate = useNavigate();

  const editMyCase = (e: any) => {
    navigate(`/my-cases/${e.case_id}`);
  };

  const handleImageClick = (e: any, image: string) => {
    e.stopPropagation();
    setCurrentImage(image);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const onClickCreateNote = (e: any) => {
    e.stopPropagation();
    setShowCreateNote(true);
  };

  return (
    <>
      <Card
        className={`${person?.is_banned && `card-danger`} bg-light card-people mx-2 mt-3 p-3 button ${!limitedAccess && `cursor-pointer`}`}
        onClick={(e) => !limitedAccess && editMyCase(person)}
      >
        <Card.Body className="ms-2 p-0">
          <Row className="align-items-center h-100">
            <Col xs={"auto"} className="m-0 p-0">
              {person?.profile && person?.profile[0] && person?.profile[0]?.data ? (
                <Image
                  className="image-people me-2 cursor-pointer"
                  src={"data:image/jpeg;base64, " + person?.profile[0]?.data}
                  onClick={(e: any) => handleImageClick(e, "data:image/jpeg;base64, " + person?.profile[0]?.data)}
                />
              ) : (
                <Image src="/blank-profile-picture.jpg" fluid className="image-people me-2" />
              )}
            </Col>
            <Col xs={8} className="p-0">
              <h6 className={"my-0 app-header-text text-wrap first-letter text-truncate"}>{person.name}</h6>
              <p className="text-muted first-letter mb-0">{person.relationship}</p>
            </Col>
          </Row>
          <Row>
            <Col className="col-12 text-end">
              {person?.is_banned === 1 ? (
                <div
                  className="position-absolute top-0 end-0"
                  data-tooltip-id="tooltip-ban"
                  data-tooltip-content={
                    banDateExpired
                      ? `Ban Expired`
                      : `Banned ${person?.banned_expiration_at ? "Until " + person?.banned_expiration_at : "Indefinitely"}`
                  }
                >
                  <Stack direction="horizontal">
                    <FontAwesomeIcon icon={faBan} className="app-danger-text me-2 mt-2 bg-light" />
                  </Stack>
                  <Tooltip id="tooltip-ban" place="top" style={{ padding: "5px 10px", zIndex: "100" }} />
                </div>
              ) : (
                person.is_guardian === 1 && (
                  <div className="position-absolute top-0 end-0">
                    <Stack direction="horizontal">
                      <FontAwesomeIcon icon={faUserShield} className="app-primary-color-inverse me-2 mt-2" />
                    </Stack>
                  </div>
                )
              )}
            </Col>
          </Row>
          <Row className="position-absolute bottom-0 end-0">
            <Col className="text-end p-2 me-3">
              <IconEmbeddedButton onClickButton={(e: any) => onClickCreateNote(e)} tooltipText="Create Note" icon={faFileText} />
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Image src={currentImage} fluid alt="Selected" />
        </Modal.Body>
      </Modal>
      <CreateNoteModal
        showModal={showCreateNote}
        setShowModal={setShowCreateNote}
        caseId={person?.case_id}
        name={person?.name}
        person={person}
        types={types}
        setUserToSave={setUserToSave}
        setShowToast={setShowToast}
        setToastText={setToastText}
        setToastBody={setToastBody}
        limitedAccess={limitedAccess}
      />
    </>
  );
};

export default PeopleCard;
